/* unplugin-vue-components disabled */import { render } from "./industrySelect.vue?vue&type=template&id=3b663b81"
import script from "./industrySelect.vue?vue&type=script&lang=js"
export * from "./industrySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__